import { StiiizyCardData } from './stiiizy-card-data';
import { Variant } from '../product/dto/variant';

export class StiiizyStrainCardData extends StiiizyCardData {
  protected override getGridSizeHelperForCapsules(variant: Variant): string | null {
    const n = variant?.packagedQuantity ?? 0;
    return `${n} cap`
      .pluralizer()
      .addRule({ isPlural: n > 1, useApostrophe: false, word: 'cap' })
      .pluralize();
  }

  protected override getGridSizeHelperForEdiblesThatAreNotReadyToDrinkBeverages(variant: Variant): string | null {
    const quantity = variant?.packagedQuantity;
    switch (true) {
      case !quantity:
        return this.getFormattedUnitSizeFor(variant);
      default:
        return `${variant?.packagedQuantity} ${this.edibleNonReadyToDrinkPackageQuantityWord(variant)}`;
    }
  }

  protected override getGridSizeHelperForEverythingElse(variant: Variant): string | null {
    return this.getFormattedUnitSizeFor(variant);
  }
}
